// extracted by mini-css-extract-plugin
export default {"root":"paging_root__ieSGQ","root--compact":"paging_root--compact__HP+i+","displayed-rows":"paging_displayed-rows__foTOj","spacer":"paging_spacer__crHgK"};